import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonSmall = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained Small button"}
        value={'<Button size={"small"}>Small</Button>'}
      >
        <Button size={"small"}>Small</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonSmall;
